export default "__VITE_ASSET__Dxr5asiW__"